import styled from '@emotion/styled';

export const StyledNavList = styled.ul();
